
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/amazonecs",
      function () {
        return require("private-next-pages/services/amazonecs/index.tsx");
      }
    ]);
  